import WaveSurfer from 'wavesurfer.js';

/**
 * Generate waveform peaks (PCM array) from an audio file URL
 *
 * @param {string|Blob} audioSource - URL string or Blob/File of audio
 * @param {object} options - Optional: { length, accuracy }
 * @returns {Promise<number[]>} Resolves to a peak array
 */
export async function generatePeaksFromURL(audioSource, options = {}) {
  const {
    maxLength = 300,     // number of samples
    accuracy = 1000,    // precision
  } = options;
    
  const container = document.createElement('audio'); // Not added to DOM

    const url = (audioSource instanceof Blob) ? URL.createObjectURL(audioSource) : audioSource;


  return new Promise((resolve, reject) => {
    const wavesurfer = WaveSurfer.create({
        container,
        url: url,
        backend: 'WebAudio'
    });

    wavesurfer.once('ready', () => {
      try {
        const peaks = wavesurfer.exportPeaks({channels:1, maxLength, accuracy});
        resolve(peaks);
      } catch (err) {
        reject(err);
      } finally {
        wavesurfer.destroy();
      }
    });

    wavesurfer.once('error', (e) => {
      reject(e);
      wavesurfer.destroy();
    });
  });
}
